import Vue from 'vue'
import Vuex from 'vuex'
import App from './modules/App'
import Session from './modules/Session'
import Socket from './modules/Socket'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        app: App,
        game: Session,
        socket: Socket,
    }
})